import { render } from "./TrainerManagement.vue?vue&type=template&id=517af32e&scoped=true"
import script from "./TrainerManagement.vue?vue&type=script&lang=js"
export * from "./TrainerManagement.vue?vue&type=script&lang=js"

import "./TrainerManagement.vue?vue&type=style&index=0&id=517af32e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517af32e"]])

export default __exports__